// src/components/Dashboard/charts/CompletionTimeByUserChart.tsx
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Empty } from "antd";

interface CompletionTimeUserData {
  user_id: number;
  email: string;
  first_name: string;
  last_name: string;
  avg_days: number;
  count: number;
}

interface CompletionTimeByUserChartProps {
  data: CompletionTimeUserData[];
}

const CompletionTimeByUserChart: React.FC<CompletionTimeByUserChartProps> = ({
  data,
}) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex justify-center items-center h-64">
        <Empty description="No user completion time data available" />
      </div>
    );
  }

  // Format the data for the chart
  const formattedData = data
    .map((item) => ({
      ...item,

      name:
        `${item.first_name} ${item.last_name}`.trim() ||
        item.email.split("@")[0],
      avg_days: Number(item.avg_days.toFixed(1)),
    }))
    .slice(0, 10); // Limit to top 10 users for better visibility

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-gray-200 shadow-md rounded-md">
          <p className="font-medium text-gray-600">{label}</p>
          <p className="text-green-600">
            Tiempo Promedio Completado:{" "}
            <span className="font-bold">{payload[0].value}</span> días
          </p>
          <p className="text-gray-600">
            Folders completados:{" "}
            <span className="font-bold">{payload[0].payload.count}</span>
          </p>
          <p className="text-gray-500 text-xs mt-1">
            {payload[0].payload.email}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="h-64 w-full">
      <ResponsiveContainer>
        <BarChart
          data={formattedData}
          layout="vertical"
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
          <XAxis
            type="number"
            tick={{ fill: "#6b7280" }}
            tickLine={{ stroke: "#e5e7eb" }}
            axisLine={{ stroke: "#e5e7eb" }}
            label={{
              value: "Días",
              position: "insideBottom",
              offset: -5,
              fill: "#6b7280",
            }}
          />
          <YAxis
            dataKey="name"
            type="category"
            tick={{ fill: "#6b7280" }}
            tickLine={{ stroke: "#e5e7eb" }}
            axisLine={{ stroke: "#e5e7eb" }}
            width={100}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar
            dataKey="avg_days"
            name="Tiempo Promedio Completado (Días)"
            fill="#10b981"
            radius={[0, 4, 4, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CompletionTimeByUserChart;
